import { useContext, useEffect, useRef, useState } from 'react'
import api from '../../services/api'
import { SL_Grid } from '../../components/grid/SL_Grid'
import { clients_grid_columns } from './grid_columns/clients_grid_columns'
import CustomToolbar from '../../components/grid/CustomToolbar'
import { SL_Button } from '../../components/buttons/Button'
import { displayMessage } from '../../helpers/messages'
import { useNavigate } from 'react-router-dom'
import ClientFilters from './components/ClientFilters'
import { ModalCreateClient } from './components/ModalCreateClient'
import { GeneralContext } from '../../context/GeneralContext/GeneralContext'
import exportToExcel from '../../services/export'
import { DateTime } from 'luxon'
import { findUserTypeByCode, formatCpf } from '../../helpers/helper'

export default function ListClients({}) {
    const formRef = useRef()
    const { mobile_mode } = useContext(GeneralContext)

    const [clients, setClients] = useState([])
    const [gridLoading, setGridLoading] = useState(false)

    const [rowOnFocus, setRowOnFocus] = useState(false)

    const [modalCreateClientIsOpen, setModalCreateClientIsOpen] = useState(false)

    const navigate = useNavigate()

    useEffect(() => {
        loadAllClients()
    }, [])

    const loadAllClients = async params => {
        setGridLoading(true)
        try {
            const { data } = await api.client.list(params ?? {})

            setClients(data)
        } catch (error) {
            console.log(error)
        } finally {
            setGridLoading(false)
        }
    }

    return (
        <>
            <ClientFilters formRef={formRef} loadClients={loadAllClients} setGridLoading={setGridLoading} setClients={setClients} />

            {modalCreateClientIsOpen && (
                <ModalCreateClient isOpen={modalCreateClientIsOpen} onClose={setModalCreateClientIsOpen} reloadClients={loadAllClients} />
            )}

            <SL_Grid
                rows={clients ?? []}
                sortingMode={'server'}
                components={{
                    Toolbar: () => (
                        <>
                            <div className="flex justify-between flex-row ss:flex-row">
                                <CustomToolbar />
                                <div className={`flex ${mobile_mode ? 'flex-col' : 'flex-row'}`}>
                                    <SL_Button className="my-1 mr-1" disabled={!rowOnFocus} onClick={() => navigate(`/clients/${rowOnFocus.id}`)}>
                                        {displayMessage('CLIENT_DETAILS')}
                                    </SL_Button>
                                    <SL_Button className="my-1 mr-1" onClick={() => setModalCreateClientIsOpen(true)}>
                                        {displayMessage('CREATE_CLIENT')}
                                    </SL_Button>
                                </div>
                            </div>
                        </>
                    ),
                }}
                disableFilter={false}
                onRowClick={params => {
                    setRowOnFocus(params.row)
                }}
                columns={clients_grid_columns}
                className="flex-1 min-h-[61vh] max-h-[100vh]"
                loading={gridLoading}
            />
        </>
    )
}
